<template>
  <div class="common-detail" v-cloak>
    <div class="title">{{detail.title}}</div>
    <div class="detail">
      <span>添加时间:{{detail.add_time | parseTime('{y}-{m}-{d}')}}</span>
      <span>作者:{{detail.issuer}}</span>
      <span>来源:国家海洋标准计量中心</span>
      <span>阅读次数:{{detail.views}}</span>
    </div>
     <div class="article-content ql-editor" v-html="detail.content">
     
    </div>
    <div class="article-content">
      <div v-for="(item,index) in detail.file_url" :key="index">
        <a :href="item.url">{{item.name}}</a>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  props: ["detail"]
};
</script>
<style lang="less" scoped>
@import "../../common/minix.less";
[v-cloak] {
  display: none!important;
}
.common-detail {
  min-height: 500 / @rem;
}
.common-detail .title {
  font-size: 36/@rem;
  color: #222;
  text-align: center;
  margin-bottom: 20/@rem;
  font-weight: 600;
  line-height: 56 / @rem;
}
.common-detail .detail {
  font-size: 0;
  text-align: center;
  margin-bottom: 30/@rem;
  line-height: 32.8 / @rem;
}
.common-detail .detail > span {
  font-size: 24/@rem;
  margin: 0 10/@rem;
}
.article-content {
  font-size: 30/@rem;
  line-height: 50/@rem;
}
.article-content /deep/ p {
  margin-bottom: 20/@rem;
}
.article-content /deep/ img {
  max-width: 100%;
  display: block;
  margin: 0 auto 20/@rem;
}
.article-content a{
  font-size: 30/@rem;
    color: blue;
    display: inline-block;
    height: 40px;
    line-height: 40px;
    box-sizing: border-box;
}

</style>




// WEBPACK FOOTER //
// src/components/common/fileDown.vue